module.exports = __webpack_public_path__ + "static/img/beite.9518fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/beite.jpg
// module id = 53sv
// module chunks = 1